import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APProgramDetailsQuery } from '../../../../../plan/queries/ap_program_details_query';
import { FeedbackSuggestedPlanModel } from '../../models/feedback_suggested_plan_model';
import { AdvisorHeaderDetailsQuery } from '../../queries/advisor_plan_details_query';
import { AdvisorSentFeedbackDiffQuery } from '../../queries/advisor_sent_feedback_diff_query';
class PlanFeedbackSuggestions {
  private advisorLabel: string = '';
  private commentOnly: boolean;
  constructor(
    private appConfigModel: any,
    private ngAPAdvisorSentFeedbackDiffQuery: AdvisorSentFeedbackDiffQuery,
    private ngAPProgramDetailsQuery: APProgramDetailsQuery,
    private acceptDeclinePlanFeedbacksCommand: ICommand,
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
    private feedbackAcceptDeclineRevokeHelper: ng.IServiceProviderFactory
  ) {
    this.advisorLabel = _4.upperFirst(appConfigModel.model.member_configs.advisor_label || 'Advisor');
  }

  $onInit() {
    const showAcknowledgement = this.ngAPAdvisorSentFeedbackDiffQuery.result.showAcknowledge;
    this.commentOnly = !showAcknowledgement && this.ngAPAdvisorSentFeedbackDiffQuery.result.hasCommentOnly;
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackSuggestions', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_suggestions/plan_feedback_suggestions.html',
  controller: PlanFeedbackSuggestions
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_suggestions/plan_feedback_suggestions.ts